import React from 'react'

const UnderConstruction: React.FC = () => {
	return (
		<>
			<>This page is under construction, we will come back with new content</>
		</>
	)
}
export default UnderConstruction
